var _filter, _filter2, _filter3, _pattern, _rect, _rect2, _text, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgcKtp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 550",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f8fafc",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#e2e8f0",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#cbd5e1",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "processGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#059669",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#047857",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "documentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#2563eb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1e40af",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "duplicateGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#dc2626",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#b91c1c",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aiGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#7c3aed",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6d28d9",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "outputGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0ea5e9",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#0284c7",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0369a1",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "dropShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 4,
    stdDeviation: 4,
    floodColor: "#000000",
    floodOpacity: 0.15
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 3,
    floodColor: "#000000",
    floodOpacity: 0.1
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#e2e8f0",
    strokeWidth: 0.5,
    opacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 550,
    fill: "url(#bgGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 550,
    fill: "url(#grid)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 45,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    fill: "#1f2937"
  }, "\n    Document Analysis &amp; Deduplication Process\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inputSection"
  }, /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 95,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 18,
    fontWeight: 600,
    fill: "#374151"
  }, "\n      Input Documents\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#documentGradient)",
    filter: "url(#dropShadow)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 20,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#documentGradient)",
    filter: "url(#dropShadow)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#documentGradient)",
    filter: "url(#dropShadow)",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 10,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#duplicateGradient)",
    filter: "url(#dropShadow)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 5,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#documentGradient)",
    filter: "url(#dropShadow)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "white",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 15,
    width: 45,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 25,
    width: 40,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 48,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 45,
    width: 35,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 55,
    width: 42,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 65,
    width: 38,
    height: 2.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 25,
    r: 16,
    fill: "#ef4444",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 25,
    r: 12,
    fill: "white",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 115 20 L 125 20 L 120 30 Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 33,
    r: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 220)",
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#documentGradient)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "white",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 15,
    width: 45,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 25,
    width: 40,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 48,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 45,
    width: 35,
    height: 2.5,
    rx: 1.25
  }))), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 330,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 14,
    fontWeight: 500,
    fill: "#6b7280"
  }, "\n      Mixed Documents\n    "), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 348,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 14,
    fontWeight: 500,
    fill: "#6b7280"
  }, "\n      with Duplicates\n    "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 90 0",
    stroke: "#10b981",
    strokeWidth: 5,
    fill: "none",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80 -8 L 90 0 L 80 8",
    stroke: "#10b981",
    strokeWidth: 5,
    fill: "none",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: -2,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "25;75;25",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 2,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "50;90;50",
    dur: "2.5s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "analysisSection"
  }, /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 95,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 18,
    fontWeight: 600,
    fill: "#374151"
  }, "\n      AI Analysis Engine\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 140,
    rx: 25,
    fill: "url(#aiGradient)",
    filter: "url(#dropShadow)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeWidth: 2.5,
    fill: "white",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 70,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 105,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 25,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 75,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 115,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 45,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 95,
    r: 5
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeWidth: 1.5,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 35,
    x2: 95,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 35,
    x2: 95,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 70,
    x2: 95,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 70,
    x2: 95,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 105,
    x2: 95,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 105,
    x2: 95,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 25,
    x2: 170,
    y2: 45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 50,
    x2: 170,
    y2: 45
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 75,
    x2: 170,
    y2: 95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 100,
    x2: 170,
    y2: 95
  }))), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 155,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#1f2937"
  }, "\n        Content Analysis\n      "), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 170,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#1f2937"
  }, "\n        Similarity Detection\n      "), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 185,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#1f2937"
  }, "\n        Classification\n      ")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 100,
    rx: 15,
    fill: "white",
    stroke: "#e5e7eb",
    strokeWidth: 2,
    filter: "url(#softShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 25,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "#1f2937"
  }, "\n        Analysis Steps:\n      "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 45,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#374151"
  }, "\n        \u2022 Content Extraction\n      "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 58,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#374151"
  }, "\n        \u2022 Semantic Comparison\n      "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 71,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#374151"
  }, "\n        \u2022 Duplicate Identification\n      "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 84,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#374151"
  }, "\n        \u2022 Policy Compliance Check\n      ")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(560, 230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 90 0",
    stroke: "#10b981",
    strokeWidth: 5,
    fill: "none",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80 -8 L 90 0 L 80 8",
    stroke: "#10b981",
    strokeWidth: 5,
    fill: "none",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 2,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "25;75;25",
    dur: "2.2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: -2,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "50;90;50",
    dur: "2.8s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "deduplicationSection"
  }, /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 95,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 18,
    fontWeight: 600,
    fill: "#374151"
  }, "\n      Deduplication Process\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 140,
    rx: 20,
    fill: "url(#processGradient)",
    filter: "url(#dropShadow)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "white",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 18,
    fill: "url(#processGradient)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: -3,
    width: 44,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -22,
    width: 6,
    height: 44,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -16,
    width: 32,
    height: 6,
    rx: 3,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -16,
    width: 32,
    height: 6,
    rx: 3,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    values: "0;360",
    dur: "4s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140, 90)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 12,
    fill: "url(#processGradient)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -2,
    width: 32,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -16,
    width: 4,
    height: 32,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -12,
    width: 24,
    height: 4,
    rx: 2,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -12,
    width: 24,
    height: 4,
    rx: 2,
    transform: "rotate(-45)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    values: "360;0",
    dur: "3s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 35,
    r: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 60,
    r: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 85,
    r: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30 35 Q 45 30 55 50",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30 60 Q 45 55 55 70",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30 85 Q 45 90 55 80",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 60 Q 115 55 130 75",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 100 60 Q 115 65 130 105",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 80,
    r: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 110,
    r: 3.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 155,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#1f2937"
  }, "\n        Smart Deduplication\n      "), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 170,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#1f2937"
  }, "\n        Policy-Aware Processing\n      ")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 100,
    rx: 15,
    fill: "white",
    stroke: "#e5e7eb",
    strokeWidth: 2,
    filter: "url(#softShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 25,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "#1f2937"
  }, "\n        Deduplication Features:\n      "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 45,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#374151"
  }, "\n        \u2022 Adaptive Algorithms\n      "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 58,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#374151"
  }, "\n        \u2022 Context Preservation\n      "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 71,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#374151"
  }, "\n        \u2022 Government Compliance\n      "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 84,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#374151"
  }, "\n        \u2022 Efficiency Optimisation\n      ")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(860, 230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 90 0",
    stroke: "#10b981",
    strokeWidth: 5,
    fill: "none",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80 -8 L 90 0 L 80 8",
    stroke: "#10b981",
    strokeWidth: 5,
    fill: "none",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: -1,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "25;75;25",
    dur: "2.4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 2,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "50;90;50",
    dur: "3s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "outputSection"
  }, /*#__PURE__*/React.createElement("text", {
    x: 1050,
    y: 95,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 18,
    fontWeight: 600,
    fill: "#374151"
  }, "\n      Organised Dataset\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970, 130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#outputGradient)",
    filter: "url(#dropShadow)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "white",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 15,
    width: 45,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 25,
    width: 40,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 48,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 45,
    width: 35,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 55,
    width: 42,
    height: 2.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 25,
    r: 14,
    fill: "#10b981",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113 25 L 118 30 L 127 21",
    stroke: "white",
    strokeWidth: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970, 240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#outputGradient)",
    filter: "url(#dropShadow)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "white",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 15,
    width: 45,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 25,
    width: 40,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 48,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 45,
    width: 35,
    height: 2.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 25,
    r: 14,
    fill: "#10b981",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 113 25 L 118 30 L 127 21",
    stroke: "white",
    strokeWidth: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(940, 360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 120,
    rx: 15,
    fill: "#f0fdf4",
    stroke: "#22c55e",
    strokeWidth: 2,
    filter: "url(#softShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 25,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "#15803d"
  }, "\n        Results:\n      "), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 45,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#166534"
  }, "\n        \u2022 Reduced Storage Costs\n      "), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 58,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#166534"
  }, "\n        \u2022 Improved Data Quality\n      "), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 71,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#166534"
  }, "\n        \u2022 Faster Information Retrieval\n      "), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 84,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#166534"
  }, "\n        \u2022 Enhanced Compliance\n      "), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 97,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#166534"
  }, "\n        \u2022 Streamlined Workflow\n      "), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 110,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', sans-serif",
    fontSize: 11,
    fill: "#166534"
  }, "\n        \u2022 Policy Adaptability\n      ")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    fill: "url(#aiGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 400,
    r: 100,
    fill: "url(#processGradient)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    stroke: "#6b7280",
    strokeWidth: 1.5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 200 120 Q 600 80 1000 120"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgcKtp);
export default __webpack_public_path__ + "static/media/svgc-ktp.84c6156b08be52ace776fd8f7adaf86c.svg";
export { ForwardRef as ReactComponent };